<nz-tag [nzColor]="statusColor">
  <span nz-icon [nzType]="statusIcon"></span>
  <span>{{status | i18nSelect: scannerStatusTranslation}}</span>
</nz-tag>
@switch (action) {
  @case ('resume') {
    <button (click)="resume.emit()" nzSize="large" nz-button nzType="primary">
      <span nz-icon nzType="play-circle"></span>
    </button>
  }
  @default {
    <button (click)="pause.emit()" nzSize="large" nz-button nzDanger nzType="primary">
      <span nz-icon nzType="pause-circle"></span>
    </button>
  }
}
